import { render, staticRenderFns } from "./clientProfileVouchers.vue?vue&type=template&id=576e5578&scoped=true"
import script from "./clientProfileVouchers.vue?vue&type=script&lang=js"
export * from "./clientProfileVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e5578",
  null
  
)

export default component.exports